module.exports = __webpack_public_path__ + "static/media/facebook.d651082e.png";